import { type ComponentPropsWithoutRef } from "react";

type ButtonProps = ComponentPropsWithoutRef<"button"> & {
  /** Look of the button */
  variant?: "primary" | "secondary" | "danger" | "ghost";
  /** Smaller padding, for tables */
  size?: "sm" | "md";
};

const VARIANTS: Record<NonNullable<ButtonProps["variant"]>, string> = {
  primary:
    "bg-sky-600 text-white hover:bg-sky-700 focus-visible:ring-sky-500/40",
  secondary:
    "border border-slate-300 bg-white text-slate-700 hover:bg-slate-50 focus-visible:ring-slate-400/40",
  danger:
    "bg-rose-600 text-white hover:bg-rose-700 focus-visible:ring-rose-500/40",
  ghost: "text-slate-600 hover:bg-slate-100 focus-visible:ring-slate-400/40",
};

/** Button with the portal's variants. */
export const Button = ({
  variant = "primary",
  size = "md",
  className = "",
  type = "button",
  ...props
}: ButtonProps) => (
  <button
    type={type}
    className={`inline-flex items-center justify-center gap-1.5 rounded-md font-medium transition focus:outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-50 ${
      size === "sm" ? "px-2.5 py-1 text-xs" : "px-3.5 py-2 text-sm"
    } ${VARIANTS[variant]} ${className}`}
    {...props}
  />
);
